export default __webpack_public_path__ + "static/avatarModalBg-6c12fe9fb6c2ec89642fb8f1e44b40b3.png";